// when we add new views we need some way to load some reasonable defaults
// for now we are hard coding them here (note they need to be in the new data format)
export const DEFAULT_VIEW_PREFS = {
  bookings: {
    'id': 'bookings',
    'name': 'Bookings',
    'tab_order': [
      '0'
    ],
    'tabs': {
      '0': {
        'fixedpanels': {
          'HistoricalBookings': {
            'width': 2,
            'id': 'HistoricalBookings',
            'params': {
              'options': {}
            },
            'type': 'HistoricalBookings',
            'seq': 2,
            'height': 5
          },
          'HistoricalBookingsMetadata': {
            'width': 2,
            'id': 'HistoricalBookingsMetadata',
            'params': {
              'options': {}
            },
            'type': 'HistoricalBookingsMetadata',
            'seq': 1,
            'height': 5
          }
        },
        'id': 0,
        'name': 'Bookings',
        'panels': {},
        'type': 'fixed'
      }
    }
  },
  historical2infrastructure: {
    "tab_order": [
      "0", "1"
    ],
    "name": "Infrastructure",
    "tabs": {
      "0": {
        "fixedpanels": {
          "HistoricalInfrastructureMetadataXml":{
            "width": 2,
            "id": "HistoricalInfrastructureMetadataXml",
            "params": {
              "options": {}
            },
            "type": "HistoricalInfrastructureMetadataXml",
            "seq": 1,
            "height": 5
          },
          "HistoricalInfrastructureXml":{
            "width": 2,
            "id": "HistoricalInfrastructureXml",
            "params": {
              "options": {
                "sortAsc": false,
                "sortIndex": 2,
                "displaySummary": [
                  "systemxml.systemcount",
                  "systemxml.sumcallcount",
                  "systemxml.sumcallcountvideo",
                  "systemxml.sumcallcountaudio",
                  "systemxml.sumcallminute",
                  "systemxml.sumcallminutevideo",
                  "systemxml.sumcallminuteaudio"
                ],
                "displayDetail": [
                  "dimsystem.systemname",
                  "dimsystem.systemtype",
                  "systemxml.license",
                  "fctsystem.callcount",
                  "fctsystem.callminute",
                  "dimsystem.vyoptamonitored",
                  "systemxml.availabilitypercent",
                  "systemxml.downpercent"
                ],
                "pageSize": 25,
                "resize": false,
                "dataset": "SystemXml",
                "pageNum": 1
              }
            },
            "type": "HistoricalInfrastructureXml",
            "seq": 2,
            "height": 5
        }},
        "panels": {},
        "name": "Infrastructure",
        "selectedUtilizationValues": {
          "daysPerWeek": 5,
          "hoursPerDay": 8
        },
        "id": 0,
        "type": "fixed"
      },
      "1": {
        "fixedpanels": {
          "HistoricalTrunksMetadataXml": {
            "width": 2,
            "id": "HistoricalTrunksMetadataXml",
            "type": "HistoricalTrunksMetadataXml",
            "seq": 1,
            "height": 5,
            "params": {
              "options": {}
            }
          },
          "HistoricalTrunksXml": {
            "width": 2,
            "id": "HistoricalTrunksXml",
            "type": "HistoricalTrunksXml",
            "seq": 2,
            "height": 5,
            "params": {
              "options": {
                "resize": false,
                "id": "HistoricalTrunksXml",
                "dataset": "TrunkXml",
                "sortAsc": true,
                "sortIndex": 2,
                "columnOptions": [],
                "pageSize": 25,
                "pageNum": 1
              }
            }
          }
        },
        "name": "Trunks",
        "panels": {},
        "selectedUtilizationValues": {
          "daysPerWeek": 5,
          "hoursPerDay": 8
        },
        "id": 1,
        "type": "fixed"
      }
    },
    "id": "historical2infrastructure"
  },
  historical2user: {
    "tab_order": [
      "0"
    ],
    "name": "Users",
    "tabs": {
      "0": {
        "fixedpanels": {
          "HistoricalUserMetadataXml":{
            "width": 2,
            "id": "HistoricalUserMetadataXml",
            "params": {
              "options": {}
            },
            "type": "HistoricalUserMetadataXml",
            "seq": 1,
            "height": 5
          },
          "HistoricalUserXml": {
            "width": 2,
            "id": "HistoricalUserXml",
            "params": {
              "options": {}
            },
            "type": "HistoricalUserXml",
            "seq": 2,
            "height": 5
          }
        },
        "panels": {},
        "name": "User",
        "selectedUtilizationValues": {
          "daysPerWeek": 5,
          "hoursPerDay": 8
        },
        "id": 0,
        "type": "fixed"
      }
    },
    "id": "historical2user"
  },
  historical2networks: {
    "tab_order": [
      "0"
    ],
    "name": "Networks",
    "tabs": {
      "0": {
        "fixedpanels": {
          "HistoricalNetworksMetadataXml": {
            "width": 2,
            "id": "HistoricalNetworksMetadataXml",
            "params": {
              "options": {}
            },
            "type": "HistoricalNetworksMetadataXml",
            "seq": 1,
            "height": 5
          },
          "HistoricalNetworksXml": {
            "width": 2,
            "id": "HistoricalNetworksXml",
            "params": {
              "options": {
                "sortAsc": false,
                "sortIndex": 2,
                "displaySummary": [
                  "networkxml.networkcount",
                  "networkxml.participantcount",
                  "networkxml.participantminute"
                ],
                "displayDetail": [
                ],
                "pageSize": 25,
                "resize": false,
                "dataset": "NetworkXml",
                "pageNum": 1
              }
            },
            "type": "HistoricalNetworksXml",
            "seq": 2,
            "height": 5
          }
        },
        "panels": {},
        "name": "Networks",
        "id": 0,
        "type": "fixed"
      }
    },
    "id": "historical2networks"
  }
};
